import React from "react"

import CdsCheckout from "pages/cds-checkout"

const cdsRoutes = [
  {
    path: "/cds-checkout",
    component: <CdsCheckout />
  }
]

export default cdsRoutes